{
  "title": "Cannot reserve an event shuttle seat",
  "description": "How to troubleshoot a failed shuttle booking, a greyed-out button, or a missing confirmation email.",
  "headings": [
    "Symptom",
    "Most common causes",
    "Diagnosis",
    "Normal result",
    "Still stuck"
  ],
  "symptom": "Pressing Reserve a seat shows an error, the button is greyed out, or an email-only booking never receives its confirmation email.",
  "causes": [
    "Your email is not verified (signed-in booking needs a verified email)",
    "You already hold a booking or waitlist spot for that day and direction, which locks the other trips",
    "The 12-hour booking cutoff before departure has passed, or the trip is not open yet",
    "Rider contact details have not been provided (required for the first booking)",
    "The email-only confirmation link is older than 30 minutes or was already used",
    "The email belongs to an account that must use normal sign-in (for example a platform administrator)",
    "More than 3 requests from the same email within 10 minutes, after which no email is sent"
  ],
  "diagnosis": [
    {
      "title": "Step 1",
      "description": "Read the message under the trip card. \"You already have a seat or waitlist spot for that date and direction\" means cancel the existing booking before choosing another trip; \"Reservations for this shuttle have closed\" means the 12-hour cutoff has passed."
    },
    {
      "title": "Step 2",
      "description": "If it asks you to verify your email, open the verification email, complete it and retry on the booking page."
    },
    {
      "title": "Step 3",
      "description": "If it asks for rider contact details, enter your real name and tick the confirmation; saving completes the booking automatically."
    },
    {
      "title": "Step 4",
      "description": "No email for an email-only booking: check spam and the spelling of the address. The link works for 30 minutes and only once; request a new one on the booking page after that. When one email makes too many requests the system stops sending and answers exactly as for success, so wait 10 minutes and try again."
    },
    {
      "title": "Step 5",
      "description": "If the page says the email must use normal sign-in, sign in on the login page and book from there."
    }
  ],
  "resolution": "Once the cause is fixed you can book. If the trip is simply full, join the waitlist; you are promoted automatically and emailed when someone cancels.",
  "stillStuck": [
    "Event name and trip code",
    "Booking date and direction",
    "Time it happened",
    "The error message on screen",
    "Screenshot"
  ],
  "doNotProvide": [
    "Password",
    "Verification code",
    "Ride QR or credential",
    "Token"
  ],
  "nextSteps": "If it is still not resolved, open the event Help desk, pick Transport and send a case."
}
